import { create } from 'zustand';

interface LivePreviewState {
    /**
     * True once a live preview connection to the Bigfoot Dashboard was confirmed
     * via the postMessage handshake (any BIGFOOT_* message from parent/opener).
     * Set by every usePreviewReceiver instance, regardless of the preview type
     * (page or design), so consumers can react to the established connection.
     */
    isPreviewConnected: boolean;
    setPreviewConnected: (isPreviewConnected: boolean) => void;
}

export const useLivePreviewStore = create<LivePreviewState>((set) => ({
    isPreviewConnected: false,
    setPreviewConnected: (isPreviewConnected) => set({ isPreviewConnected }),
}));

export default useLivePreviewStore;
